/** Move an enabled-app id from one index to another within the ordered list. */
export function reorderEnabledAppIds(
  ids: readonly string[],
  fromIndex: number,
  toIndex: number
): string[] {
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= ids.length ||
    toIndex >= ids.length ||
    fromIndex === toIndex
  ) {
    return [...ids];
  }
  const next = [...ids];
  const [item] = next.splice(fromIndex, 1);
  if (item === undefined) return [...ids];
  next.splice(toIndex, 0, item);
  return next;
}

/** Move an enabled-app id by one step (−1 up / +1 down). */
export function moveEnabledAppId(
  ids: readonly string[],
  appId: string,
  direction: -1 | 1
): string[] {
  const fromIndex = ids.findIndex((id) => id.toLowerCase() === appId.toLowerCase());
  if (fromIndex < 0) return [...ids];
  return reorderEnabledAppIds(ids, fromIndex, fromIndex + direction);
}

/**
 * Sort catalog display: enabled apps first in saved menu order,
 * then disabled apps in catalog definition order.
 */
export function sortCatalogForDisplay<T extends { id: string; enabled: boolean }>(
  catalog: readonly T[],
  enabledAppIds: readonly string[]
): T[] {
  const byId = new Map(catalog.map((item) => [item.id.toLowerCase(), item]));
  const enabled: T[] = [];
  const seen = new Set<string>();

  for (const id of enabledAppIds) {
    const item = byId.get(id.toLowerCase());
    if (!item || !item.enabled) continue;
    enabled.push(item);
    seen.add(item.id.toLowerCase());
  }

  const disabled = catalog.filter((item) => !seen.has(item.id.toLowerCase()));
  return [...enabled, ...disabled];
}
